const Config = {
    USERPOORID: 'ap-southeast-1_qdLBV678Q',
    CLIENTID: 'nqd39e8p3b3024f2dq272l3va',
}

export default Config;
